import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {CrudImplementation} from '@shared/services/crud-implementation';

@Injectable({
  providedIn: 'root'
})
export class CrudCompaniesService extends CrudImplementation {
  protected url = '/v1/admin/companies';

  getUserTools(companyId: string): Observable<any> {
    const url = '/v1/admin/companies/' + companyId + '/usertools';
    return this.http.get(this.serverRoot + url);
  }

  removeUserTool(id: string): Observable<any> {
    const url = '/v1/admin/users/tools/' + id;
    return this.http.delete(this.serverRoot + url);
  }

}
